module.exports = __webpack_public_path__ + "img/svg/phone-in-talk-green-7c287142.svg";